const tiles = {
  B_1: { code: 'B_1', title: '1 Bam', type: 'Bam', icon: '1🎋' },
  B_2: { code: 'B_2', title: '2 Bam', type: 'Bam', icon: '2🎋' },
  B_3: { code: 'B_3', title: '3 Bam', type: 'Bam', icon: '3🎋' },
  B_4: { code: 'B_4', title: '4 Bam', type: 'Bam', icon: '4🎋' },
  B_5: { code: 'B_5', title: '5 Bam', type: 'Bam', icon: '5🎋' },
  B_6: { code: 'B_6', title: '6 Bam', type: 'Bam', icon: '6🎋' },
  B_7: { code: 'B_7', title: '7 Bam', type: 'Bam', icon: '7🎋' },
  B_8: { code: 'B_8', title: '8 Bam', type: 'Bam', icon: '8🎋' },
  B_9: { code: 'B_9', title: '9 Bam', type: 'Bam', icon: '9🎋' },
  C_1: {
    code: 'C_1',
    title: '1 Crack',
    type: 'Crack',
    icon: '1 一',
  },
  C_2: {
    code: 'C_2',
    title: '2 Crack',
    type: 'Crack',
    icon: '2 二',
  },
  C_3: {
    code: 'C_3',
    title: '3 Crack',
    type: 'Crack',
    icon: '3 三',
  },
  C_4: {
    code: 'C_4',
    title: '4 Crack',
    type: 'Crack',
    icon: '4 四',
  },
  C_5: {
    code: 'C_5',
    title: '5 Crack',
    type: 'Crack',
    icon: '5 五',
  },
  C_6: {
    code: 'C_6',
    title: '6 Crack',
    type: 'Crack',
    icon: '6 六',
  },
  C_7: {
    code: 'C_7',
    title: '7 Crack',
    type: 'Crack',
    icon: '7 七',
  },
  C_8: {
    code: 'C_8',
    title: '8 Crack',
    type: 'Crack',
    icon: '8 八',
  },
  C_9: {
    code: 'C_9',
    title: '9 Crack',
    type: 'Crack',
    icon: '9 九',
  },
  D_1: { code: 'D_1', title: '1 Dot', type: 'Dot', icon: '1 ⚫' },
  D_2: { code: 'D_2', title: '2 Dot', type: 'Dot', icon: '2 ⚫' },
  D_3: { code: 'D_3', title: '3 Dot', type: 'Dot', icon: '3 ⚫' },
  D_4: { code: 'D_4', title: '4 Dot', type: 'Dot', icon: '4 ⚫' },
  D_5: { code: 'D_5', title: '5 Dot', type: 'Dot', icon: '5 ⚫' },
  D_6: { code: 'D_6', title: '6 Dot', type: 'Dot', icon: '6 ⚫' },
  D_7: { code: 'D_7', title: '7 Dot', type: 'Dot', icon: '7 ⚫' },
  D_8: { code: 'D_8', title: '8 Dot', type: 'Dot', icon: '8 ⚫' },
  D_9: { code: 'D_9', title: '9 Dot', type: 'Dot', icon: '9 ⚫' },
  N_G: {
    code: 'N_G',
    title: 'Green Dragon',
    type: 'Dragon',
    icon: '🐲 🟢',
  },
  N_R: {
    code: 'N_R',
    title: 'Red Dragon',
    type: 'Dragon',
    icon: '🐲 🔴',
  },
  N_W: {
    code: 'N_W',
    title: 'White Dragon',
    type: 'Dragon',
    icon: '🐲 ⚪',
  },
  W_N: {
    code: 'W_N',
    title: 'North Wind',
    type: 'Wind',
    icon: 'N 🌬️',
  },
  W_E: {
    code: 'W_E',
    title: 'East Wind',
    type: 'Wind',
    icon: 'E 🌬️',
  },
  W_S: {
    code: 'W_S',
    title: 'South Wind',
    type: 'Wind',
    icon: 'S 🌬️',
  },
  W_W: {
    code: 'W_W',
    title: 'West Wind',
    type: 'Wind',
    icon: 'W 🌬️',
  },
  X_X: {
    code: 'X_X',
    title: 'Flower or Season',
    type: 'Special',
    icon: '🌸 🌤',
  },
}

export default tiles
